module.exports = __webpack_public_path__ + "static/img/trophy.6bf879be.png";